import { render } from "./list-kompetensi-profesi.vue?vue&type=template&id=751edc07&scoped=true"
import script from "./list-kompetensi-profesi.vue?vue&type=script&lang=js"
export * from "./list-kompetensi-profesi.vue?vue&type=script&lang=js"

import "./list-kompetensi-profesi.vue?vue&type=style&index=0&id=751edc07&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751edc07"]])

export default __exports__